<template src="./index.html"></template>
<script>
// var _this=this
import bus from '../../util/bus';
import { checkoutUserPeriod, dggqueryv2, optionv2, getRoleMenuIdListByUser, ssologoutsaml, getProductVersionInfo } from '../../../api/home.js';
import configHttpProduct from '../../../../configHttpProduct.js';
import { getdata } from './data.js';
export default {
	inject: ['reload'],
	data() {
		return {
			productVersion: {
				versionCode: "",
				versionDate: "",
				registerDeadline: ""
			},
			collapse: true,
			show: false,
			introduceshow:false,
			time: null,
			value: '',
			options: [
				{
					label: '退出登录',
					value: 'loginout'
				}
				// {
				// 	label: '修改密码',
				// 	value: 'ChangePassword'
				// }
			],
			entity: [],
			listout: [],
			list: [],
			modify: false,
			userInfo: JSON.parse(localStorage.getItem('currentLoginUser')) || {},
			sysUserSTXX: JSON.parse(localStorage.getItem('sysUserSTXX')) || {},
			suosq: this.$getdefultMonth(),
			Roletk: false,
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: getdata().headData,
			tableData: [],
			tablekey: 0
			/* 表格 */
		};
	},

	created() {
		if (this.$emptyandnull(this.userInfo) || this.$emptyandnull(localStorage.getItem('sysUserSTXX'))) {
			this.$router.push('/login');
		}
		this.userInfo = JSON.parse(localStorage.getItem('currentLoginUser'));
		this.sysUserSTXX = JSON.parse(localStorage.getItem('sysUserSTXX'));

		getProductVersionInfo().then(res => {
			if (res.data.code == '200') {
				let data = res.data.data;
				if(data) {
					this.productVersion.versionCode = data.versionCode;
					this.productVersion.versionDate = data.versionDate;
					this.productVersion.registerDeadline = data.registerDeadline;
				}
			}
		});
	},
	methods: {
		forupdata(e){
			window.open(e)
		},
		SwitchingEntity() {
			if (this.$refs.tablebox.getSelectionval().length == 1) {
				let params = {};
				params.id = this.$refs.tablebox.getSelectionval()[0].id;
				optionv2(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('切换成功');
						localStorage.setItem('currentLoginUser', JSON.stringify(res.data.data.currentLoginUser));
						localStorage.setItem('sysUserSTXX', JSON.stringify(res.data.data.sysUserSTXX));
						localStorage.setItem('token', res.data.data.token);
						getRoleMenuIdListByUser().then(res1 => {
							res1.data.data.menuList.unshift({
								children: [],
								icon: 'meauicon5',
								id: '2',
								resCode: 'home',
								resName: '首页',
								checked: false
							});
							localStorage.setItem('MenuPermission', JSON.stringify(res1.data.data.menuList));
							localStorage.setItem('resources', JSON.stringify(res1.data.data.buttonList));
							var meaurouter = [];
							digui(res1.data.data.menuList);
							function digui(data) {
								data.forEach(v => {
									if (v.children) {
										if (v.resCode != '' && v.resName != '凭证导入' && v.resName != '账务查询' && v.resName != '报表中心') {
											meaurouter.push(v.resCode);
										}
										digui(v.children);
									} else {
										if (v.resCode == 'VoucherQuery') {
											meaurouter.push('VoucherDetail');
											meaurouter.push('PreviewVoucher');
											meaurouter.push('GLView');
											meaurouter.push('SubLedgerTable');
										}
										meaurouter.push(v.resCode);
									}
								});
							}
							localStorage.setItem('meaurouter', meaurouter);
							this.Roletk = false;
							if (this.$emptyandnull(this.userInfo) || this.$emptyandnull(localStorage.getItem('sysUserSTXX'))) {
								this.$router.push('/login');
							}
							this.userInfo = JSON.parse(localStorage.getItem('currentLoginUser'));
							this.sysUserSTXX = JSON.parse(localStorage.getItem('sysUserSTXX'));
							this.$router.push({
								path: '/' + meaurouter[0]
							});
							this.reload();
							// this.$router.go(0)
						});
					} else {
						this.$message.error(res.data.message);
					}
				});
			} else {
				this.$message.error('请选择一个需要切换的实体');
				return;
			}
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = 'id';
			params.order = 'desc';
			dggqueryv2(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
					this.Roletk = true;
				}
			});
		},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		},
		/* 表格 */

		active_show() {
			this.show = !this.show;
		},
		introduce_show() {
			this.introduceshow = !this.introduceshow;
		},
		inputx(e) {
			this.listout = [];
			this.list.map(item => {
				item.children.map(item1 => {
					if (item1.resName.indexOf(e.target.value) == 0) {
						if (this.listout.length == 0) {
							this.listout.push({
								resName: item.resName,
								children: [{ ...item1 }]
							});
						} else {
							this.listout.map(item2 => {
								if (item2.resName == item.resName) {
									item2.children.push({ ...item1 });
								} else {
									this.listout.push({
										resName: item.resName,
										children: [{ ...item1 }]
									});
								}
							});
						}
					}
				});
			});
			if (e.target.value == '') {
				this.Search();
			}
		},
		tz(e) {
			this.$router.push('/' + e);
		},
		forheadchange(e) {
			if (e == 'loginout') {
				// ssologoutsaml().then(res => {
				// 	localStorage.removeItem("token")
				// 	this.$router.push('/login_Fin');
				// });
				//跳转到产品门户网站
				let portalLogin = localStorage.getItem("portalLogin");
				let token = localStorage.getItem("token");
				localStorage.clear();
				if(configHttpProduct.portalSwitch && portalLogin == "true"){
					window.location.href = configHttpProduct.portalBaseURL+"?token="+token;
				}else{
					this.$router.push('/login');
				}
				
				
			} else {
				this.modify = true;
			}
		},
		Search() {
			this.listout = [];
			this.list.map(item => {
				this.listout.push({ ...item });
			});
		}
	},
	mounted() {
		if (JSON.parse(localStorage.getItem('MenuPermission'))[JSON.parse(localStorage.getItem('MenuPermission')).length - 1].resCode == 'ConfigurationCenter') {
			this.list = JSON.parse(localStorage.getItem('MenuPermission'))[JSON.parse(localStorage.getItem('MenuPermission')).length - 1].children;
		}
		this.Search(this.list);
		// if (document.body.clientWidth < 1500) {
		// }
		bus.$on('log', content => {
			this.show = false;
			this.Search();
		});
		bus.$on('log', content => {
			this.introduceshow = false;
		});
	}
};
</script>

<style scoped>
@import url('./index.css');
</style>
<style scoped lang="less">
.backinput {
	/deep/.el-input--small .el-input__inner {
		background-color: white !important;
	}
}
.header/deep/.el-input--small .el-input__inner {
	border: none;
	background-color: #354257;
}

.header/deep/.el-icon-search {
	font-size: 19px;
	position: relative;
	top: 3px;
	margin-left: 17px;
}
</style>
